import { Routes, Route } from 'react-router-dom';
import MainPage from '../pages/MainPage/MainPage';
import SavedPage from '../pages/SavedPage/SavedPage';
import BucketPage from '../pages/BucketPage/BucketPage';
import CatalogPage from '../pages/CatalogPage/CatalogPage';
import BannerPage from '../pages/BannerPage/BannerPage';
import ReviewsPage from '../pages/ReviewsPage/ReviewsPage';

export const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/index.html" element={<MainPage />} />
      <Route path="/catalog" element={<CatalogPage />} />
      <Route path="/saved" element={<SavedPage />} />
      <Route path="/bucket" element={<BucketPage />} />
      <Route path="/banner/:id" element={<BannerPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="*" element={<MainPage />} />
    </Routes>
  );
};
